import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const BookmarkIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 18"
    fill="none"
    {...props}
  >
    <Path d="M1.5 16.875V0.875H14.5V16.875L8.19697 11.4205L1.5 16.875Z" stroke={color} strokeWidth="1.75" strokeLinejoin="round" />
  </Svg>
);

BookmarkIcon.displayName = 'BookmarkIcon';
